import React from 'react'
import { Row } from 'react-styled-flexboxgrid'
import PropTypes from 'prop-types'
import { graphql, StaticQuery, Link } from 'gatsby'
import _ from 'lodash'
import { Button } from '..'
import * as styles from './styles'
import ikeaImage from '../../../assets/ikea-case.svg'

const propTypes = {
  data: PropTypes.object.isRequired
}

const SelectedUseCase = ({ data }) => {
  return (
    <styles.Container>
      <Row reverse>
        <styles.UseCaseCol md={6} lg={7} xs={12}>
          <styles.UseCaseInfo>
            <styles.UseCaseCardHeader>
              {data.title}
            </styles.UseCaseCardHeader>
            <styles.UseCaseDescription>
              {data.description}
            </styles.UseCaseDescription>
            <styles.UseCaseBenefit>
              {data.benefit}
            </styles.UseCaseBenefit>
            <styles.ReadMoreButton>
              <Link to="/product/use-cases">
                <Button size="small">{data.buttonText}</Button>
              </Link>
            </styles.ReadMoreButton>
          </styles.UseCaseInfo>
        </styles.UseCaseCol>
        <styles.UseCaseCol md={6} lg={5} xs={12}>
          <styles.IkeaImage
            src={ikeaImage}
            alt="ikea demand simulator"
          />
        </styles.UseCaseCol>
      </Row>
    </styles.Container>
  )
}

SelectedUseCase.propTypes = propTypes

export default () => (
  <StaticQuery
    query={graphql`
      query GetSelectedUseCase {
        allYaml(filter: {file: {eq: "selected-use-case"}}) {
          edges {
            node {
              title
              description
              benefit
              buttonText
            }
          }
        }
      }
    `
    }
    render={(data) => {
      const { allYaml } = data
      const { edges } = allYaml
      const { node } = _.first(edges)
      return (
        <SelectedUseCase data={node} />
      )
    }}
  />
)
